export default "__VITE_ASSET__OLS5TsQx__"